import "./App.css";

import FormatRoutes from "./Projects/AppPokemons/FormatRoutes";

function App() {
  return (
    <div className={`App-header`}>
      <FormatRoutes />
    </div>
  );
}

export default App;
